import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import RoleList from "@/Components/common/client/useraccess/roleaccess/RoleList";
import UserAccessTypes from "@/Components/common/client/useraccess/UserAccessTypes";
import {
  deSelectAllRoles,
  fetchClientRoles,
  setClientRolesLoading,
  updatePagination,
} from "@/reducers/client_user/roleAccess";
import { updateactivePages } from "@/reducers/clientcommon";

import useTitle from "../../../../utilities/hooks/useTitle";

const RoleAccess = () => {
  useTitle("Roles");
  const { filters, pagination } = useSelector((state) => state.clientRoles);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      updatePagination({
        ...pagination,
        currentPage: 1,
        isLastPage: false,
      }),
    );
    dispatch(setClientRolesLoading(true));
    dispatch(deSelectAllRoles());
    dispatch(fetchClientRoles());
    // dispatch(fetchNewUserRolesData())
    dispatch(
      updateactivePages({
        activePage: "userAccess",
        activeSubPage: "roles",
      }),
    );
  }, []);

  return (
    <div className="flex flex-col gap-4">
      <UserAccessTypes />
      <RoleList />
    </div>
  );
};

export default RoleAccess;
